import useCurrentUserAccount from 'src/hooks/useCurrentUserAccount';
import useCurrentWalletAdapter from 'src/hooks/useCurrentWalletAdapter';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import useFeatureFlagStore from 'src/stores/featureFlag/useFeatureFlagStore';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

export const useIsElfaWidgetEligible = () => {
	const isMobileScreenSize = useIsMobileScreenSize();
	const wallet = useCurrentWalletAdapter();
	const currentAccount = useCurrentUserAccount();
	const isElfaWidgetFlagEnabled = useFeatureFlagStore((s) =>
		s.flagEnabled('ENABLE_ELFA_WIDGET')
	);
	const isEmulatingAccount = useDriftStore((s) => s.isEmulatingAccount);
	const isEligible =
		wallet.connected &&
		currentAccount &&
		!!wallet.publicKey?.equals(currentAccount.authority) &&
		isElfaWidgetFlagEnabled &&
		!isMobileScreenSize &&
		!isEmulatingAccount;

	return isEligible;
};
